/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Allowed_Ranks_LabelInputs */



/**
* | output |
* | --- |
* | "Restrict to championship ranks" |
*
* @param {Promo_Allowed_Ranks_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_allowed_ranks_label = /** @type {((inputs?: Promo_Allowed_Ranks_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Allowed_Ranks_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restreindre aux rangs de championnat")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restringir a rangos de campeonato")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Restringir a categorias de campeonato")
	if (locale === "it") return /** @type {LocalizedString} */ ("Limita ai rank di campionato")
	return /** @type {LocalizedString} */ ("Restrict to championship ranks")
});